import { render, staticRenderFns } from "./onlineOrders.vue?vue&type=template&id=28411f0e&scoped=true"
import script from "./onlineOrders.vue?vue&type=script&lang=js"
export * from "./onlineOrders.vue?vue&type=script&lang=js"
import style0 from "./onlineOrders.vue?vue&type=style&index=0&id=28411f0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28411f0e",
  null
  
)

export default component.exports